<template>
  <div class="home">
    <div class="carousel">
      <carousel :type="'minigame'"></carousel>
    </div>
    <div class="container">
      <div id="lottie"></div>
    </div>
  </div>
</template>

<script>
  import carousel from '@/components/Home/carousel'
  // import animationData from '@/assets/data.json'

  const logo = require('@/assets/arcadialogo_footer.png');
  export default {
    name: "Home",
    components: {carousel},
    data() {
      return {
        logo: logo,
      }
    },
    mounted() {
      // var params = {
      //   container: document.getElementById('lottie'),
      //   renderer: 'svg',
      //   loop: true,
      //   autoplay: true,
      //   animationData: animationData
      // };
      // var anim;
      //
      // anim = lottie.loadAnimation(params);
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../style/home';
</style>
